export default __webpack_public_path__ + "static/media/ExternalAnalytics-exampleEvent.f3476d9d.jpg";